import { Button, Input, Switch, Typography } from "@material-tailwind/react";

import { Link } from "react-router-dom";
import { auth } from "../firebase";
import { firebaseLogin } from "../api/api";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const token = await userCredential.user.getIdToken();
      localStorage.setItem("token", token);
      localStorage.setItem("tokenType", "Bearer");

      await firebaseLogin(token, "individual").then((response) => {
        console.log(response);
        if (response) {
          localStorage.setItem("user", JSON.stringify(response));
        }
      });

      navigate("/dashboards");
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div className="w-screen h-screen m-auto bg-white flex justify-center items-center">
      <form className="w-96 h-content border-2 border-gray-300 rounded-lg shadow-md p-8">
        <div className="mb-6">
          <Input
            className="autofill:shadow-[inset_0_0_0px_1000px_rgb(252,252,252)]"
            autoComplete="email"
            variant="static"
            type="email"
            label="Email Address"
            size="lg"
            value={email}
            id="email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="mb-6">
          <Input
            className="autofill:shadow-[inset_0_0_0px_1000px_rgb(252,252,252)]"
            autoComplete="password"
            variant="static"
            type="password"
            label="Password"
            size="lg"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="flex justify-between items-center mb-6">
          <div className="form-group form-check mr-3">
            <Switch
              defaultChecked={true}
              label={
                <div>
                  <Typography
                    variant="small"
                    color="gray"
                    className="font-normal"
                  >
                    Remember me
                  </Typography>
                </div>
              }
            />
          </div>
          <br />

          <Link to="/forgot-password">
            <Typography
              as="span"
              className="ml-1 text-md font-normal inline text-delft-blue"
            >
              Forgot password?
            </Typography>
          </Link>
        </div>

        <div className="text-center">
          <Button variant="outlined" fullWidth onClick={handleSubmit}>
            LOG IN
          </Button>

          <div className="text-md font-normal pt-12">
            Don't have an account?&nbsp;&nbsp;&nbsp;&nbsp;
            <Link to="/register">
              <Typography
                as="span"
                className="ml-1 font-bold inline text-delft-blue"
              >
                Register
              </Typography>
            </Link>
          </div>
        </div>

        <div className="relative flex pt-2 pb-4 items-center">
          <div className="flex-grow border-t border-gray-400"></div>
          <span className="flex-shrink mx-4 text-gray-400">or</span>
          <div className="flex-grow border-t border-gray-400"></div>
        </div>

        {/* 
        <div className="h-12 overflow-hidden">
          <div id="signInDiv" />
        </div> */}

        <Button className="flex bg-delft-blue" fullWidth>
          <div className="mx-auto flex">
            <svg
              className="mr-2 -ml-1 w-4 h-4"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="google"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 488 512"
            >
              <path
                fill="currentColor"
                d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
              ></path>
            </svg>
            CONNECT WITH GOOGLE
          </div>
        </Button>

        <Button className="flex mt-3 bg-delft-blue" fullWidth>
          <div className="mx-auto flex">
            <svg
              className="mr-2 -ml-1 w-4 h-4"
              aria-hidden="true"
              focusable="false"
              data-prefix="fab"
              data-icon="github"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 496 512"
            >
              <path
                fill="currentColor"
                d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-2.8 0-5.2-1.6-5.2-3.6 0-2 2.3-3.6 5.2-3.6 2.9 0 5.2 1.6 5.2 3.6zm-30.4-6.5c-.7 2.1 1.5 4.3 4.3 4.9 2.8.6 5.8-.5 6.5-2.6.7-2.1-1.5-4.3-4.3-4.9-2.8-.6-5.8.5-6.5 2.6zm44.2-1.7c-2.9.8-4.8 3.2-4.3 5.7.4 2.6 3.1 4.1 6 3.3 2.9-.8 4.8-3.2 4.3-5.7-.4-2.6-3.1-4.1-6-3.3zm46.5-8.3c-2.6 1.8-3.5 5.3-1.7 7.9 1.8 2.6 5.3 3.5 7.9 1.7 2.6-1.8 3.5-5.3 1.7-7.9-1.8-2.6-5.3-3.5-7.9-1.7zm41.1-7.4c-2.6 1.8-3.5 5.3-1.7 7.9 1.8 2.6 5.3 3.5 7.9 1.7 2.6-1.8 3.5-5.3 1.7-7.9-1.8-2.6-5.3-3.5-7.9-1.7zm-24.7 11.2c-2.9.8-4.8 3.2-4.3 5.7.4 2.6 3.1 4.1 6 3.3 2.9-.8 4.8-3.2 4.3-5.7-.4-2.6-3.1-4.1-6-3.3zm79.2-16.2c-2.8 0-5.2 1.6-5.2 3.6 0 2 2.3 3.6 5.2 3.6 2.9 0 5.2-1.6 5.2-3.6 0-2-2.3-3.6-5.2-3.6zM248 8C111 8 0 119 0 256c0 110 71.2 203.1 170 236 12.4 2.3 16.9-5.4 16.9-12v-42.2c-69.2 15-83.8-33.4-83.8-33.4-11.3-28.8-27.6-36.5-27.6-36.5-22.6-15.4 1.7-15.1 1.7-15.1 25 1.8 38.2 25.7 38.2 25.7 22.2 38 58.3 27 72.5 20.6 2.2-16.1 8.7-27 15.8-33.2-55.3-6.3-113.6-27.6-113.6-122.7 0-27.1 9.7-49.3 25.6-66.7-2.6-6.3-11.1-31.8 2.4-66.4 0 0 20.9-6.7 68.6 25.6 19.9-5.5 41.3-8.2 62.5-8.3 21.2.1 42.6 2.8 62.5 8.3 47.7-32.3 68.6-25.6 68.6-25.6 13.5 34.6 5 60.1 2.4 66.4 15.9 17.4 25.6 39.6 25.6 66.7 0 95.3-58.4 116.3-113.9 122.5 8.9 7.7 16.9 23 16.9 46.3v68.7c0 6.7 4.5 14.4 17 12 98.8-32.9 170-126 170-236C496 119 385 8 248 8z"
              />
            </svg>
            CONNECT WITH GITHUB
          </div>
        </Button>
      </form>
    </div>
  );
};

export default Login;
